"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingGovIcon64Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.BuildingGovIcon64Regular = forwardRef_1.forwardRef('BuildingGovIcon64Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 64 }, props),
        react_1.default.createElement("path", { d: "M26.208 11.177a9.375 9.375 0 0 1 11.584 0l18.656 14.659a1.5 1.5 0 1 0 1.854-2.36L39.645 8.819a12.375 12.375 0 0 0-15.29 0L5.698 23.477a1.5 1.5 0 1 0 1.854 2.359l18.656-14.659Z" }),
        react_1.default.createElement("path", { d: "M17 27.5a1.5 1.5 0 0 0-3 0v21a1.5 1.5 0 0 0 3 0v-21Z" }),
        react_1.default.createElement("path", { d: "M7.5 55a1.5 1.5 0 0 0 0 3h49a1.5 1.5 0 0 0 0-3h-49Z" }),
        react_1.default.createElement("path", { d: "M26.5 26a1.5 1.5 0 0 1 1.5 1.5v21a1.5 1.5 0 0 1-3 0v-21a1.5 1.5 0 0 1 1.5-1.5Z" }),
        react_1.default.createElement("path", { d: "M39 27.5a1.5 1.5 0 0 0-3 0v21a1.5 1.5 0 0 0 3 0v-21Z" }),
        react_1.default.createElement("path", { d: "M48.5 26a1.5 1.5 0 0 1 1.5 1.5v21a1.5 1.5 0 0 1-3 0v-21a1.5 1.5 0 0 1 1.5-1.5Z" })));
});
